var hmo_radio_options = function() {
  $(".js-consultations-container").on("change", ".js-hmo-plans-options .js-walk-in-button", function() {
    $(this).parents(".js-hmo-plans-options").siblings(".js-existing-plan-fields").hide();
    $(this).parents(".js-hmo-plans-options").siblings(".js-new-plan-fields").hide();
  });

  $(".js-consultations-container").on("change", ".js-hmo-plans-options .js-existing-plan-button", function() {
    $(this).parents(".js-hmo-plans-options").siblings(".js-existing-plan-fields").slideDown();
    $(this).parents(".js-hmo-plans-options").siblings(".js-new-plan-fields").hide();
  });

  $(".js-consultations-container").on("change", ".js-hmo-plans-options .js-new-plan-button", function() {
    $(this).parents(".js-hmo-plans-options").siblings(".js-existing-plan-fields").hide();
    $(this).parents(".js-hmo-plans-options").siblings(".js-new-plan-fields").slideDown();
  });

  $(".js-hmo-plans-options input[type='radio']:checked").trigger("change");
}

$(document).ready(hmo_radio_options);
$(document).on('page:load', hmo_radio_options);